import { render, staticRenderFns } from "./block-settlement.vue?vue&type=template&id=76c59b16&scoped=true"
import script from "./block-settlement.vue?vue&type=script&lang=js"
export * from "./block-settlement.vue?vue&type=script&lang=js"
import style0 from "./block-settlement.vue?vue&type=style&index=0&id=76c59b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c59b16",
  null
  
)

export default component.exports